var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArdShirt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 121,
    viewBox: "0 0 83 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4325_1960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 83,
    height: 121
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 121,
    rx: 4,
    fill: "#E4FBFF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4325_1960)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8103 53.4061C56.6974 37.9948 36.6434 33.52 25.0183 43.4114L45.4643 67.4411C32.4891 55.0744 14.8037 52.1024 4.17044 61.1499L24.6088 85.1707C11.6344 72.8106 -6.04564 69.8419 -16.6767 78.8874L30.8091 134.697C41.4402 125.651 41.3406 107.724 31.2175 92.9378L51.6562 116.959C62.2895 107.912 62.1877 89.9785 52.058 75.1907L72.5041 99.2205C84.1292 89.3292 82.9231 68.8174 69.8103 53.4061Z",
    fill: "#A1EDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4325_1960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -17,
    y: 38,
    width: 98,
    height: 97
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8103 53.4061C56.6974 37.9948 36.6434 33.52 25.0183 43.4114L45.4643 67.4411C32.4891 55.0744 14.8037 52.1024 4.17044 61.1499L24.6088 85.1707C11.6344 72.8106 -6.04564 69.8419 -16.6767 78.8874L30.8091 134.697C41.4402 125.651 41.3406 107.724 31.2175 92.9378L51.6562 116.959C62.2895 107.912 62.1877 89.9785 52.058 75.1907L72.5041 99.2205C84.1292 89.3292 82.9231 68.8174 69.8103 53.4061Z",
    fill: "#271A58"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4325_1960)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.8614,
    cy: 53.6418,
    r: 25.0281,
    transform: "rotate(-60.3933 55.8614 53.6418)",
    fill: "#75E5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArdShirt);
export default __webpack_public_path__ + "static/media/сard-shirt.4d53d3f942979a0dcb35c53a2889e78b.svg";
export { ForwardRef as ReactComponent };